module.exports = __webpack_public_path__ + "img/supercomputer.6dfa43a2.jpg";